import {
	LocationStatusEnum,
	locationStatusToColor,
	LocationTypeEnum,
} from '@splitsecondconnect/ultramarine-shared';

import { SelectItem } from 'app/shared/models/select-item.type';

export const LOCATION_STATUSES: SelectItem<LocationStatusEnum>[] = [
	{
		value: LocationStatusEnum.OPEN,
		displayValue: 'locations|status|open',
		pillColor: locationStatusToColor(LocationStatusEnum.OPEN),
	},
	{
		value: LocationStatusEnum.CLOSED,
		displayValue: 'locations|status|closed',
		pillColor: locationStatusToColor(LocationStatusEnum.CLOSED),
	},
];
export const LOCATION_TYPES: SelectItem<LocationTypeEnum>[] = [
	{
		value: LocationTypeEnum.OTHER,
		displayValue: 'locations|type|other',
	},
	{
		value: LocationTypeEnum.BODYSHOP,
		displayValue: 'locations|type|bodyshop',
	},
	{
		value: LocationTypeEnum.OFFICE,
		displayValue: 'locations|type|office',
	},
	{
		value: LocationTypeEnum.PARKING_LOT,
		displayValue: 'locations|type|parking-lot',
	},
	{
		value: LocationTypeEnum.WORKSHOP,
		displayValue: 'locations|type|workshop',
	},
];
